// Framework
import { call, put, select, takeEvery } from 'redux-saga/effects';
import Raven from 'raven-js';
import { getAuth } from 'actions/auth/login';
import { getCountries } from 'api/countries';
import { getLocale } from 'actions/language/selectors';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';

// Actions
export const FETCH_COUNTRY_DATA = 'COUNTRY/FETCH_COUNTRY_DATA';
export const SUCCESS_FETCHING_COUNTRY_DATA =
  'COUNTRY/SUCCESS_FETCHING_COUNTRY_DATA';
export const ERROR_FETCHING_COUNTRY_DATA =
  'COUNTRY/ERROR_FETCHING_COUNTRY_DATA';
export const TOGGLE_COUNTRY_FILTER_DROPDOWN =
  'UI/COUNTRY/TOGGLE_COUNTRY_FILTER_DROPDOWN';
export const CHANGE_COUNTRY_FILTER = 'UI/COUNTRY/CHANGE_COUNTRY_FILTER';

/*** Action Creators ***/
export const fetchCountryData = () => ({
  type: FETCH_COUNTRY_DATA
});

export const successFetchingCountryData = (data) => ({
  type: SUCCESS_FETCHING_COUNTRY_DATA,
  countries: data
});

export const errorFetchingCountryData = () => ({
  type: ERROR_FETCHING_COUNTRY_DATA
});

export const toggleCountryFilterDropdown = () => ({
  type: TOGGLE_COUNTRY_FILTER_DROPDOWN
});

export const changeCountryFilter = (countryFilter) => ({
  type: CHANGE_COUNTRY_FILTER,
  countryFilter
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  countries: [],
  countryFilter: '',
  countryFilterDropdownOpen: false
};

export default function CountryReducer(
  state = DEFAULT_STATE,
  { countries, countryFilter, error, type } = {}
) {
  const { countryFilterDropdownOpen } = state;
  switch (type) {
    case ERROR_FETCHING_COUNTRY_DATA:
      Raven.captureException(error, { state });
      return {
        ...state,
        error
      };
    case SUCCESS_FETCHING_COUNTRY_DATA:
      return {
        ...state,
        countries
      };
    case TOGGLE_COUNTRY_FILTER_DROPDOWN:
      return {
        ...state,
        countryFilterDropdownOpen: !countryFilterDropdownOpen
      };
    case CHANGE_COUNTRY_FILTER:
      return {
        ...state,
        countryFilter
      };
    case FETCH_COUNTRY_DATA:
    default:
      return state;
  }
}

/*** Sagas ***/
// Worker
export function* getCountriesWorker() {
  try {
    const auth = yield select(getAuth);
    const locale = yield select(getLocale);
    const data = yield call(getCountries, locale, auth);
    yield put(successFetchingCountryData(data.countries));
  } catch (err) {
    yield pushFormattedError(err);
  }
}

// Watcher
export function* countrySaga() {
  yield takeEvery(FETCH_COUNTRY_DATA, getCountriesWorker);
}



// WEBPACK FOOTER //
// ./src/actions/travelSecurity/countries/actions.js